import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

function TimeAgo({ children, interval = 60, className }) {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!interval) return;
    const id = setInterval(() => setTick((t) => t + 1), interval * 1000);
    return () => clearInterval(id);
  }, [interval]);

  const target = dayjs(children);
  // When the viewer's device clock trails the server's, a timestamp for
  // something that already happened (e.g. a just-created notification) can
  // land a few seconds in the future from the device's point of view.
  // dayjs().fromNow() then reads "in a few seconds", which is never correct
  // for an event that already happened — clamp any future timestamp to "just
  // now" instead of showing a future-facing relative time.
  const label = target.isAfter(dayjs()) ? "just now" : target.fromNow();

  return <span className={className}>{label}</span>;
}

export default TimeAgo;
